import {
  LinkButton as DSLinkButton,
  LinkButtonProps as DSLinkButtonProps,
} from '@s-group/design-system-components/LinkButton/LinkButton'
import { VisuallyHidden } from '@s-group/design-system-components/VisuallyHidden/VisuallyHidden'
import { JSX, MouseEventHandler } from 'react'

import { IconWrapper } from '../common/IconWrapper'

export type LinkButtonVariant = 'primary' | 'plain'

export interface LinkButtonProps {
  'aria-label'?: string
  className?: string
  color?: 'primary' | 'neutral'
  compact?: boolean
  'data-testid'?: string
  href?: string
  icon?: JSX.Element
  iconPos?: 'before' | 'after'
  label: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  target?: string
  variant?: LinkButtonVariant
  iconOnly?: boolean
}

const variantPropsMap = {
  primary: { variant: 'filled' },
  plain: { variant: 'plain', style: { fontWeight: 400 } },
} satisfies Record<LinkButtonVariant, Partial<DSLinkButtonProps>>

export const LinkButton = ({
  // Always include href to make link focusable
  // "#" to make it work with testing library role query (empty string doesn't work)
  href = '#',
  label,
  variant = 'primary',
  iconOnly,
  icon,
  ...rest
}: LinkButtonProps) => {
  const variantProps = variantPropsMap[variant]
  return (
    <DSLinkButton
      href={href}
      pill={true}
      sizing="medium"
      icon={icon && <IconWrapper>{icon}</IconWrapper>}
      {...variantProps}
      {...rest}
      iconOnly={iconOnly}
    >
      {iconOnly ? <VisuallyHidden>{label}</VisuallyHidden> : <span>{label}</span>}
    </DSLinkButton>
  )
}
